<template>
    <div class="app-container">
      <list ref="list">
          <template slot="toolbar-right">
         
        </template>
        <template slot="column">
         
        </template>
      </list>
     
    </div>
  </template>
  <script>
  import curdMixins from "@/mixins/curd";
  import list from "@/components/demoapi/apilog/list";
 // import editDialog from "@/components/person/demopersonbalance/editDialog";
  
  export default {
    name: "apilog",
    mixins: [curdMixins],
    components: {
      list,
     // editDialog,
    },
    methods: {
     
     
    },
  };
  </script>